import styled from 'styled-components';
import { ReactElement } from 'react';

import { Loader, LoaderSize, TestId } from '@dreryk/react-components';

const StyledPageLoader = styled.div`
   height: 100%;
   width: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
   gap: 8px;
`;

StyledPageLoader.displayName = 'StyledPageLoader';

type PageLoaderProps = {
   readonly testId: TestId;
};

export const PageLoader = (props: PageLoaderProps): ReactElement => (
   <StyledPageLoader>
      <Loader size={LoaderSize.BIG} testId={props.testId} />
   </StyledPageLoader>
);
